export default __webpack_public_path__ + "resources/icons/d111-38ba.png";